import { useTranslation } from 'react-i18next';
import { ServicesSubSectionHeader } from '../../../services/services-subsection/services-subsection.styles';
import {
  GridContainer,
  PriceTitle,
  PriceValue,
} from '../../../../routes/parcel-content/parcel-content.styles';
import { TaxesSectionContainer } from '../parcel-taxes-info.styles';
import { Link } from '../../../../common/typography/typography.styles';
import { Step } from '../../../../models/parcelCreationFlowNavigation';

interface Props {
  stepInfo: Step | null | undefined;
}

const TaxesInfoItaly = ({ stepInfo }: Props) => {
  const { t } = useTranslation();

  const isContentStep = stepInfo?.name === 'parcel-content';

  const rawTaxesContent = stepInfo?.elements.find(
    (el) => el.type === 'action-show-raw-taxes'
  )?.content;

  const contentToRender = !isContentStep ? (
    <GridContainer>
      <PriceTitle>
        {t('create_parcel_summary_taxes_paid_by_receiver')}
      </PriceTitle>
      <PriceValue>
        {t('create_parcel_summary_taxes_paid_by_receiver_text')}
      </PriceValue>
    </GridContainer>
  ) : (
    <PriceValue>
      {rawTaxesContent?.map((contentElement) => {
        if (contentElement.link)
          return (
            <Link
              href={contentElement.link}
              target='_blank'>
              {contentElement.content}
            </Link>
          );

        return contentElement.content;
      })}
    </PriceValue>
  );

  return (
    <TaxesSectionContainer>
      <ServicesSubSectionHeader>{t('taxes_italy')}</ServicesSubSectionHeader>
      {contentToRender}
    </TaxesSectionContainer>
  );
};

export default TaxesInfoItaly;
